import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { HeaderComponent } from '../components/header/header.component';
import { FooterComponent } from '../components/footer/footer.component';
import { HomeComponent } from '../components/home/home.component';
import { LoginComponent } from '../components/login/login.component';
import { SignupComponent } from '../components/signup/signup.component';
import { ChangePassComponent } from '../components/change-pass/change-pass.component';
import { DashboardComponent } from '../components/dashboard/dashboard.component';
import { TestDashboardComponent } from '../components/dashboard/test-dashboard/test-dashboard.component';
import { EduSysViewComponent } from '../components/edu-sys/edu-sys-view/edu-sys-view.component';
import { EduSysCreateComponent } from '../components/edu-sys/edu-sys-create/edu-sys-create.component';
import { EduSysUpdateComponent } from '../components/edu-sys/edu-sys-update/edu-sys-update.component';
import { IndividualViewComponent } from '../components/indiv/individual-view/individual-view.component';
import { IndividualCreateComponent } from '../components/indiv/individual-create/individual-create.component';
import { TestSeriesComponent } from '../components/dashboard/test-series/test-series.component';
import { CompSubMappingComponent } from '../components/test-series/comp-sub-mapping/comp-sub-mapping.component';
import { TestHistoryComponent } from '../components/test-series/test-history/test-history.component';
import { TestHistoryDetailComponent } from '../components/test-series/test-history-detail/test-history-detail.component';
import { TestInstructionsComponent } from '../components/test-series/test-instructions/test-instructions.component';
import { TestQuestionPrepareInitComponent } from '../components/test-series/test-question-prepare-init/test-question-prepare-init.component';
import { VideoPlayerComponent } from '../components/video-player/video-player.component';
import { VideoConfigComponent } from '../components/video-player/video-config/video-config.component';
import { AboutComponent } from '../components/about/about.component';
import { PrivacyPolicyComponent } from '../components/privacy-policy/privacy-policy.component';
import { TermsOfUsageComponent } from '../components/terms-of-usage/terms-of-usage.component';
import { WriteToUsComponent } from '../components/write-to-us/write-to-us.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full'},
  { path: 'r-home', redirectTo: 'home', pathMatch: 'full'},
  { path: 'home', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
   /*{ path: 'signup/:sid', component: SignupComponent },*/
  { path: 'changePassword', component: ChangePassComponent },
  { path: 'header', component: HeaderComponent },
  { path: 'footer', component: FooterComponent },
  //{ path: 'r-dashbaord',   redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'test-dashboard', component: TestDashboardComponent },
  { path: 'test-dashboard/:p,:u', component: TestDashboardComponent },
  { path: 'eduSys-view', component: EduSysViewComponent },
  { path: 'eduSys-delete/:id', component: EduSysUpdateComponent },
  { path: 'eduSys-update', component: EduSysCreateComponent },
  { path: 'eduSys-create', component: EduSysCreateComponent },
  { path: 'eduSys-create/:id', component: EduSysCreateComponent },
  { path: 'individual-view', component: IndividualViewComponent },
  { path: 'individual-create', component: IndividualCreateComponent },
  { path: 'individual-update', component: IndividualCreateComponent },
  { path: 'dashboard-test-series', component: TestSeriesComponent },
  { path: 'test-instructions', component: TestInstructionsComponent },
  { path: 'test-prepare-question', component: TestQuestionPrepareInitComponent },
  { path: 'test-history', component: TestHistoryComponent },
  { path: 'dashboard-history-detail', component: TestHistoryDetailComponent },
  
  { path: 'test-series-comp-sub-mapping', component: CompSubMappingComponent},
  { path: 'about-us', component: AboutComponent },
  { path: 'term-of-usage', component: TermsOfUsageComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'write-to-us', component: WriteToUsComponent },
  { path: 'video-player', component: VideoPlayerComponent },
  { path: 'video-config', component: VideoConfigComponent }
];


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    [RouterModule.forRoot(routes)]
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
